import api from '@/services/api'
import { permissions } from '@/plugins/acl'

export default {
  getAll: {
    permission: permissions.exchangeView,
    request: ({ params }) => api.get('/exchanges', params)
  }
}
